exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-approval-timer {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  .content-approval-timer__pending {\n    color: #575757; }\n  .content-approval-timer__overdue {\n    color: red; }\n  .content-approval-timer__icon {\n    width: 13px;\n    height: 14px;\n    background-size: contain;\n    margin-right: 6px; }\n  .content-approval-timer__message {\n    font-size: 14px;\n    font-weight: 600;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!./components/content_approval_timer/index.scss
// module id = 2840
// module chunks = 69